var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1194_429)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10C16.684 10 17.3856 10.0176 18.0656 10.0464L18.8688 10.0848L19.6376 10.1304L20.3576 10.1792L21.0152 10.2304C21.7288 10.285 22.4004 10.5896 22.9116 11.0904C23.4229 11.5913 23.7411 12.2564 23.8104 12.9688L23.8424 13.3088L23.9024 14.0368C23.9584 14.7912 24 15.6136 24 16.4C24 17.1864 23.9584 18.0088 23.9024 18.7632L23.8424 19.4912C23.832 19.608 23.8216 19.7208 23.8104 19.8312C23.7411 20.5437 23.4227 21.2089 22.9113 21.7098C22.3999 22.2107 21.7282 22.5152 21.0144 22.5696L20.3584 22.62L19.6384 22.6696L18.8688 22.7152L18.0656 22.7536C17.3775 22.7835 16.6888 22.799 16 22.8C15.3112 22.799 14.6225 22.7835 13.9344 22.7536L13.1312 22.7152L12.3624 22.6696L11.6424 22.62L10.9848 22.5696C10.2712 22.515 9.59964 22.2104 9.08838 21.7096C8.57711 21.2087 8.25886 20.5436 8.1896 19.8312L8.1576 19.4912L8.0976 18.7632C8.03643 17.9769 8.00388 17.1887 8 16.4C8 15.6136 8.0416 14.7912 8.0976 14.0368L8.1576 13.3088C8.168 13.192 8.1784 13.0792 8.1896 12.9688C8.25883 12.2566 8.57697 11.5915 9.08807 11.0907C9.59917 10.5898 10.2705 10.2852 10.984 10.2304L11.6408 10.1792L12.3608 10.1304L13.1304 10.0848L13.9336 10.0464C14.622 10.0165 15.311 10.001 16 10ZM14.4 14.46V18.34C14.4 18.7096 14.8 18.94 15.12 18.756L18.48 16.816C18.5531 16.7739 18.6138 16.7133 18.6561 16.6403C18.6983 16.5672 18.7205 16.4844 18.7205 16.4C18.7205 16.3156 18.6983 16.2328 18.6561 16.1597C18.6138 16.0867 18.5531 16.0261 18.48 15.984L15.12 14.0448C15.047 14.0027 14.9642 13.9805 14.8799 13.9805C14.7956 13.9805 14.7128 14.0027 14.6399 14.0449C14.5669 14.087 14.5063 14.1477 14.4642 14.2207C14.4221 14.2937 14.3999 14.3765 14.4 14.4608V14.46Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1194_429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.7755472837f57ff670806994c4f86343.svg";
export { ForwardRef as ReactComponent };